/* Tea Lab product FAQ: opens and closes the questions. Works inside <tea-lab-faq-list>. */
(function () {
  if (customElements.get('tea-lab-faq-list')) return;
  class TeaLabFaqList extends HTMLElement {
    connectedCallback() {
      if (this._on) return;
      this._on = true;
      var self = this;
      this._multi = this.getAttribute('data-multi') === 'true';
      this._click = function (e) {
        var b = e.target.closest && e.target.closest('[data-q]');
        if (!b || !self.contains(b)) return;
        var item = b.closest('.tlf__item');
        var open = !item.classList.contains('is-open');
        if (open && !self._multi) self.items().forEach(function (o) { if (o !== item) self.set(o, false); });
        self.set(item, open);
      };
      this._key = function (e) {
        var b = e.target.closest && e.target.closest('[data-q]');
        if (!b) return;
        var all = [].slice.call(self.querySelectorAll('[data-q]')), i = all.indexOf(b), n = -1;
        if (e.key === 'ArrowDown') n = (i + 1) % all.length;
        else if (e.key === 'ArrowUp') n = (i - 1 + all.length) % all.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = all.length - 1;
        if (n < 0) return;
        e.preventDefault();
        all[n].focus();
      };
      this._select = function (e) {
        var item = e.target && e.target.closest && e.target.closest('.tlf__item');
        if (item) self.set(item, true);
      };
      this.addEventListener('click', this._click);
      this.addEventListener('keydown', this._key);
      this.addEventListener('shopify:block:select', this._select);
      // a link such as #TLF-...-q-... opens that question
      try {
        var id = decodeURIComponent((window.location.hash || '').slice(1));
        var t = id && document.getElementById(id);
        if (t && this.contains(t)) this.set(t.closest('.tlf__item'), true);
      } catch (e) {}
    }
    disconnectedCallback() {
      this._on = false;
      this.removeEventListener('click', this._click);
      this.removeEventListener('keydown', this._key);
      this.removeEventListener('shopify:block:select', this._select);
    }
    items() { return [].slice.call(this.querySelectorAll('.tlf__item')); }
    set(item, open) {
      item.classList.toggle('is-open', open);
      var b = item.querySelector('[data-q]');
      if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }
  customElements.define('tea-lab-faq-list', TeaLabFaqList);
})();
